module.exports = __webpack_public_path__ + "img/abuelo.ea827535.png";